/* eslint-disable no-nested-ternary */
import { del, get, post, put } from '@webapps/utils';

const { NX_REST_API } = process.env;

export const getInfosBusiness = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/business/${id}`,
    }),
  format: ({ data }) => data,
};

export const getBusinesses = {
  query: () =>
    get({
      url: `${NX_REST_API}/business`,
    }),
  format: ({ data }) => data,
};

export const getBusinessEmployer = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/business/employer/${id}`,
    }),
  format: ({ data }) => data,
}

export const updateBusinessEmployer = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/business/employer/${id}`,
      data,
    }),
}

export const getBusinessContractByStudent = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/business/contract/student/${id}`,
    }),
  format: ({ data }) => data,
}

export const updateBusinessContract = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/business/contract/${id}`,
      data,
    }),
}

export const getBusinessExternalByIndividual = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/partners/individual/business/external/${id}`,
    }),
  format: ({ data }) => data,
};

export const getBusinessExternalBySchool = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/partners/school/business/external/${id}`,
    }),
  format: ({ data }) => data,
}

export const getBusinessesPagination = {
  query: ({ page, size }) =>
    get({
      url: `${NX_REST_API}/business`,
      options: {
        params: {
          ...(page ? { page } : {}),
          ...(size ? { size } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

export const getBusinessesSectors = {
  query: () =>
    get({
      url: `${NX_REST_API}/jobs/module/job_sectors`,
    }),
  format: ({ data }) => data,
};

export const getBusinessesDomains = {
  query: () =>
    get({
      url: `${NX_REST_API}/jobs/module/domains`,
    }),
  format: ({ data }) => data,
};

export const getBusinessesDomainsBySectors = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/jobs/module/job_sectors/domain/${id}`,
    }),
  format: ({ data }) => data,
};

export const getBusinessPartners = {
  query: ({ id, page, size, type }) =>
    get({
      url: `${NX_REST_API}/partners/business/${id}?type=${type}&page=${page}&size=${size}`,
    }),
  format: ({ data }) => data,
};

export const searchBusinessPartners = {
  query: ({ id, keyword, trainingDomains, degreeLevels, trainingTypes, from, page, size, accept }) =>
    get({
      url: `${NX_REST_API}/partners/business/search/${id}?accept=${accept}&page=${page}&size=${size}`,
      options: {
        params: {
          ...(keyword ? { keyword } : {}),
          ...(trainingDomains ? { trainingDomains } : {}),
          ...(degreeLevels ? { degreeLevels } : {}),
          ...(trainingTypes ? { trainingTypes } : {}),
          ...(from ? { from } : {}),
        }
      }
    }),
  format: ({ data }) => data,
}

export const getOffers = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/jobs/module/offers/business/${id}`,
    }),
  format: ({ data }) => data,
};

export const getOfferById = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/jobs/module/offers/${id}`,
    }),
  format: ({ data }) => data,
};

export const updateBusinessInfoVitrine = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/business/${id}`,
      data,
    }),
};

export const updateBusinessInfoPartialVitrine = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/business/partial/${id}`,
      data,
    }),
};

export const updateBusinessPresentation = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/profile/update/presentation/${id}`,
      data,
    }),
};

export const updateGoodToKnow = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/profile/update/goodtoknow/${id}?goodtoknow=${data}`,
    }),
};

export const updateSlogan = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/profile/update/slogan/${id}?slogan=${data}`,
    }),
};

export const updateWhatTheySeek = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/profile/update/whattheyseek/${id}?whattheyseek=${data}`,
    }),
};

export const createOffer = {
  query: ({ data }) =>
    post({
      url: `${NX_REST_API}/jobs/module/offers`,
      data,
    }),
};

export const updateOffer = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/jobs/module/offers/${id}`,
      data,
    }),
};

export const getLangOffre = {
  query: () =>
    get({
      url: `${NX_REST_API}/jobs/module/worked_languages`,
    }),
  format: ({ data }) => data,
};

export const getOffresEntreprise = {
  query: ({ id, page, size, status }) =>
    get({
      url: `${NX_REST_API}/jobs/module/offers/business/${id}?page=${page}&size=${size}&status=${status}`,
    }),
  format: ({ data }) => data,
};

export const getOffresPartner = {
  query: ({ id, idSector, page, size }) =>
    get({
      // url: `${NX_REST_API}/jobs/module/offers/partners/school/${id}?page=${page}&size=${size}`,
      url: `${NX_REST_API}/jobs/module/offers/search?&status=opened&businesses=${id}&page=${page}&size=${size}`,
      options: {
        params: {
          ...(idSector ? { sectors: idSector } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

export const getOffresMap = {
  query: ({
    businesses,
    businessesExternals,
    businessExternals,
    cities,
    contracts,
    contractLengths,
    degreeLevels,
    domains,
    keyword,
    page,
    sectors,
    size,
    status,
    telework,
    accountId,
  }) =>
    get({
      url: `${NX_REST_API}/jobs/module/offers/search?page=${page}&size=${size}&status=${status}`,
      options: {
        params: {
          ...(businesses ? { businesses } : {}),
          ...(businessesExternals ? { businessesExternals } : {}),
          ...(businessExternals ? { businessExternals } : {}),
          ...(cities ? { cities } : {}),
          ...(contracts ? { contracts } : {}),
          ...(contractLengths ? { contractLengths } : {}),
          ...(degreeLevels ? { degreeLevels } : {}),
          ...(keyword ? { keyword } : {}),
          ...(sectors ? { sectors } : {}),
          ...(domains ? { domains } : {}),
          ...(telework ? { telework } : {}),
          ...(accountId ? { accountId } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

export const postSubscribeBusiness = {
  query: ({ data, id }) =>
    post({
      url: `${NX_REST_API}/jobs/module/subscriptions/owner/${id}`,
      data,
    }),
};

export const postSubscribeSchool = {
  query: ({ data, id }) =>
    post({
      url: `${NX_REST_API}/trainings/module/subscriptions/owner/${id}`,
      data,
    }),
};

export const getJobsSubscribe = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/jobs/module/subscriptions/owner/${id}`,
    }),
  format: ({ data }) => data,
};
export const getTrainingsSubscribe = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/trainings/module/subscriptions/owner/${id}`,
    }),
  format: ({ data }) => data,
};

export const getJobSubscribeDetails = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/jobs/module/subscriptions/${id}`,
    }),
  format: ({ data }) => data,
};

export const getTrainingSubscribeDetails = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/trainings/module/subscriptions/${id}`,
    }),
  format: ({ data }) => data,
};

export const deleteSubscribeJob = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/jobs/module/subscriptions/${id}`,
    }),
};

export const deleteTrainingSubscribe = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/trainings/module/subscriptions/${id}`,
    }),
};

export const getStudents = {
  query: ({ page, size }) =>
    get({
      url: `${NX_REST_API}/individual?page=${page}&size=${size}`,
    }),
  format: ({ data }) => data,
};

export const deleteASchoolPartner = {
  query: ({ businessId, schoolId }) =>
    del({
      url: `${NX_REST_API}/partners/delete?schoolId=${schoolId}&businessId=${businessId}&from=business`,
    }),
};

export const rejectASchoolPartner = {
  query: ({ businessId, schoolId }) =>
    put({
      url: `${NX_REST_API}/partners/reject?schoolId=${schoolId}&businessId=${businessId}`,
    }),
};

export const acceptASchoolPartner = {
  query: ({ businessId, schoolId }) =>
    put({
      url: `${NX_REST_API}/partners/accept?schoolId=${schoolId}&businessId=${businessId}`,
    }),
};

export const connectASchoolPartner = {
  query: ({ data }) =>
    post({
      url: `${NX_REST_API}/partners/connect?connect_type=businessToSchool`,
      data,
    }),
};

export const getBusinessSearch = {
  query: ({ keyword, domains, sectors, schoolId, page, size }) =>
    get({
      url: `${NX_REST_API}/business/search?page=${page}&size=${size}`,
      options: {
        params: {
          ...(keyword ? { keyword } : {}),
          ...(domains ? { domains } : {}),
          ...(sectors ? { sectors } : {}),
          ...(schoolId ? { schoolId } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

export const getCandidatureEntreprise = {
  query: ({
    id,
    interestLevel,
    keyword,
    offer,
    page,
    size,
    status,
    contractType,
    isRead,
    degreeLevel,
  }) =>
    get({
      url: `${NX_REST_API}/jobs/module/applications/business/${id}?page=${page}&size=${size}`,
      options: {
        params: {
          ...(status ? { status } : {}),
          ...(keyword ? { keyword } : {}),
          ...(offer ? { offer } : {}),
          ...(interestLevel ? { interestLevel } : {}),
          ...(contractType ? { contractType } : {}),
          ...(isRead ? { isRead } : {}),
          ...(degreeLevel ? { degreeLevel } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

export const getNumberJobById = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/jobs/module/offers/business/${id}/count?status=opened`,
    }),
  format: ({ data }) => data,
};

export const getNumberExternalJobById = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/jobs/module/offers/businessExternal/${id}/count?status=opened`,
    }),
  format: ({ data }) => data,
}

export const getTeamById = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/business/module/teams/business/${id}`,
    }),
  format: ({ data }) => data,
};

export const getDefaultTeamMembersByBusiness = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/business/module/teams/default/members/${id}`,
    }),
  format: ({ data }) => data,
}

export const createBusinessAffiliate = {
  query: ({ data }) =>
    post({
      url: `${NX_REST_API}/affiliates/business_affiliate`,
      data,
    }),
};

export const createTeam = {
  query: ({ data, id }) =>
    post({
      url: `${NX_REST_API}/business/module/teams/business/${id}`,
      data,
    }),
};

export const getTeams = {
  query: ({ id, keyword, page, size }) =>
    get({
      url: `${NX_REST_API}/business/module/teams/business/${id}?page=${page}&size=${size}`,
      options: {
        params: {
          ...(keyword ? { keyword } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

export const getBusinessAffiliate = {
  query: ({ contractType, status, id, job, keyword, page, size }) =>
    get({
      url: `${NX_REST_API}/affiliates/business/${id}?page=${page}&size=${size}`,
      options: {
        params: {
          ...(job ? { job } : {}),
          ...(keyword ? { keyword } : {}),
          ...(contractType ? { contractType } : {}),
          ...(status ? { status } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

export const deleteAnnonce = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/jobs/module/offers/${id}`,
    }),
};

export const getCountCandidatByAnnonce = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/jobs/module/applications/offer/${id}/count?status=all`,
    }),
  format: ({ data }) => data,
};

export const acceptApplicantJob = {
  query: ({ applicantId, trainingId }) =>
    put({
      url: `${NX_REST_API}/jobs/module/applications/accept?applicantId=${applicantId}&trainingId=${trainingId}`,
    }),
};

export const rejectApplicantJob = {
  query: ({ applicantId, trainingId }) =>
    put({
      url: `${NX_REST_API}/jobs/module/applications/reject?applicantId=${applicantId}&trainingId=${trainingId}`,
    }),
};

export const interestLevelOffer = {
  query: ({ applicantId, level, offerId }) =>
    put({
      url: `${NX_REST_API}/jobs/module/applications/interest_level?level=${level}&offerId=${offerId}&applicantId=${applicantId}`,
    }),
};

export const getStudentOnTeam = {
  query: ({ contractType, id, keyword, page, size, status }) =>
    get({
      url: `${NX_REST_API}/affiliates/students/team/${id}?status=${status}&page=${page}&size=${size}`,
      options: {
        params: {
          ...(keyword ? { keyword } : {}),
          ...(contractType ? { contractType } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

export const getStudentOnBusiness = {
  query: ({ id, keyword, page, size, status }) =>
    get({
      url: `${NX_REST_API}/affiliates/students/business/${id}/employees?status=${status}&page=${page}&size=${size}`,
      options: {
        params: {
          ...(keyword ? { keyword } : {}),
        },
      },
    }),
  format: ({ data }) => data,
}

export const getStatsTeam = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/affiliates/students/team/${id}/stats`,
    }),
  format: ({ data }) => data,
};

export const getStudentOnBusinessTeam = {
  query: ({ contractType, id, keyword, page, size, status }) =>
    get({
      url: `${NX_REST_API}/affiliates/students/business/members/${id}?status=${status}&page=${page}&size=${size}`,
      options: {
        params: {
          ...(keyword ? { keyword } : {}),
          ...(contractType ? { contractType } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};

export const getTeamInfoById = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/business/module/teams/${id}`,
    }),
  format: ({ data }) => data,
};

export const postUpdateTeam = {
  query: ({ data, id }) =>
    put({
      url: `${NX_REST_API}/business/module/teams/${id}`,
      data,
    }),
};

export const deleteTeam = {
  query: ({ id }) =>
    del({
      url: `${NX_REST_API}/business/module/teams/${id}`,
    }),
};

export const getDocumentsBusiness = {
  query: ({ id, page, size }) =>
    get({
      url: `${NX_REST_API}/business/module/documents/owner/${id}?page=${page}&size=${size}`,
    }),
  format: ({ data }) => data,
};

export const getInfoBusinessDocument = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/business/module/documents/${id}`,
    }),
  format: ({ data }) => data,
};

export const addViewBusiness = {
  query: ({ id }) =>
    put({
      url: `${NX_REST_API}/business/view/${id}`,
    }),
};

export const addViewOffer = {
  query: ({ id }) =>
    put({
      url: `${NX_REST_API}/jobs/module/offers/view/${id}`,
    }),
};
